import {Component, ElementRef, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {Config} from '../config';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import {Http, Headers, RequestOptions, Jsonp} from '@angular/http';

@Component({
    selector: 'searchTool-component',
    template: require('../tools/searchTool.component.html'),
    styles: [require('../tools/searchTool.component.css')]
})
export class SearchToolComponent {
    appSettings: Object = null;
    searchModules:Array<any> = [];
    showSearchOptions:boolean = false;
    logoImageSource:string = "./images/DMD-Logo.png";
    spinningImg:string = "./images/InternetSlowdown_Day.gif";
    operationalLayersCount:number = 0;
    localStorage:any = window.localStorage;
    @Input() urlSearchObject:string = "";
    @Output() showParcelReportWidget = new EventEmitter<boolean>();
    private disclaimerText:string = "";

    constructor(private elRef:ElementRef, private _mapService:MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService, private http:Http, private jsonp:Jsonp){
        
    }

    ngOnInit(){
        this.appSettings = Config.config[0];
        this.disclaimerText = this.appSettings["WelcomeDisclaimer"];
        this.searchModules = this.appSettings["SearchModules"];
        this._eventsService.dynamicLayerViewCreated$.subscribe(show => 
            {
                this.operationalLayersCount++;
                if(this.appSettings["Map"]["Layers"]["OperationalLayers"].length == this.operationalLayersCount){
                    this._eventsService.savedSearchSelect$.subscribe(savedSearch => {
                        this.showSelectedModule(savedSearch);
                    });
                    if(this.urlSearchObject == ""){
                        this.showSearchOptions = true;
                    }else{
                        this.getSearchObjectByQueryID();
                    }
                    // if(this.urlSearchObject != ""){
                    //     try{
                    //         var urlSearchObject:any = JSON.parse(this.urlSearchObject);
                    //     }catch(err){
                    //         this.urlSearchObject = undefined;
                    //     }
                    //     if(urlSearchObject != undefined && urlSearchObject["module"] && urlSearchObject["extent"]){
                    //         if(urlSearchObject["geometry"] != null){
                    //             var geometryObject:Object = {};
                    //             geometryObject["geometry"] = urlSearchObject["geometry"];
                    //             geometryObject["buffer"] = urlSearchObject["buffer"];
                    //             geometryObject["showOnlyWithinGeometry"] = savedSearch["showOnlyWithinGeometry"];
                    //             this._eventsService.setSavedGeometry(geometryObject);
                    //         }
                    //         this.showSelectedModule(urlSearchObject["module"]);
                    //         this._mapService.view.extent = urlSearchObject["extent"];
                    //     }
                    // }                   
                }
            }
        )
    }

    getSearchObjectByQueryID(){
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let msgBody:Object = {"queryCode": this.urlSearchObject};
        this.http.post(this.appSettings["URLShortener"]["getQueryURL"], msgBody, options).toPromise().then((response)=>{
            var queryString:string = response.json();
            console.log(queryString);
            if(queryString != ""){
                try{
                    var urlSearchObject:any = JSON.parse(queryString);
                }catch(err){
                    urlSearchObject = undefined;
                    this.showSearchOptions = true;
                }
                if(urlSearchObject != undefined && urlSearchObject["module"] && urlSearchObject["extent"]){
                    if(urlSearchObject["geometry"] != null){
                        var geometryObject:Object = {};
                        geometryObject["geometry"] = urlSearchObject["geometry"];
                        geometryObject["buffer"] = urlSearchObject["buffer"];
                        geometryObject["showOnlyWithinGeometry"] = urlSearchObject["showOnlyWithinGeometry"];
                        this._eventsService.setSavedGeometry(geometryObject);
                    }
                    this.showSelectedModule(urlSearchObject["module"]);
                    this._mapService.view.extent = urlSearchObject["extent"];
                }
                this.showSearchOptions = true;
            }
        }).catch(e=>{
            console.log(e);
            this.showSearchOptions = true;
        })
    }

    showSelectedModule(moduleObject:any){
        this._eventsService.moduleSelect(moduleObject);
        this.hideSearchTool();
    }

    hideSearchTool(){
        this._eventsService.searchToolShow(false);
    }

    getLastSavedSearch(){
        var savedSearch = JSON.parse(window.localStorage.getItem("PlanIndy_saved_search"));
        if(savedSearch["geometry"] != null){
            var geometryObject:Object = {};
            geometryObject["geometry"] = savedSearch["geometry"];
            geometryObject["buffer"] = savedSearch["buffer"];
            geometryObject["showOnlyWithinGeometry"] = savedSearch["showOnlyWithinGeometry"];
            this._eventsService.setSavedGeometry(geometryObject);
        }
        this._eventsService.savedSearchSelect(savedSearch["module"]);
        this._mapService.view.extent = savedSearch["extent"];
    }
}


// WEBPACK FOOTER //
// ./app/tools/searchTool.component.ts